<div class="responsive">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-3 col-xs-3 col-sm-12">
        <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
        <!-- <app-header></app-header>
        <app-side-bar></app-side-bar> -->
      </div>
      <div class="col-12 col-md-12 col-lg-6 col-xs-6 col-sm-12">
        <div class="drop-dash" style="min-height: 500px">
          <div class="display margin-b">
            <div class="header-style cursor" [ngClass]="{ active: activeTab === 'merchant' }"
              (click)="getScrollTo('merchant')" id="merchant">
              Merchant
            </div>
            <div class="header-style cursor" [ngClass]="{ active: activeTab === 'visitors' }"
              (click)="getScrollTo('visitors')" id="visitors">
              Visitors
            </div>
            <div class="header-style cursor" [ngClass]="{ active: activeTab === 'fellowships' }"
              (click)="getScrollTo('fellowships')" id="fellowships">
              Followers
            </div>
            <div class="header-style cursor" [ngClass]="{ active: activeTab === 'inquiries' }"
              (click)="getScrollTo('inquiries')" id="inquiries" style="position: relative;">
              Inquiries
              <span *ngIf="newInquiriesCount > 0" style="
                background: #dc3545;
                color: #fff;
                border-radius: 50%;
                padding: 2px 7px;
                font-size: 11px;
                font-weight: 700;
                margin-left: 6px;
                position: relative;
                top: -8px;
              ">{{ newInquiriesCount }}</span>
            </div>
          </div>

          <div *ngIf="activeTab == 'merchant' && loading">
            <div class="responsive">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card" style="margin-top: -95px">
                      <div class="image-wrapper div-position margin-b" style="height: 300px">
                        <img class="card-img-top" [src]="merchantDetail?.coverPhoto | merchantCoverPhoto"
                          alt="Cover Photo" (error)="onImgError($event, 'assets/placeholderCoverPhoto.jpeg')" />
                        <!-- coverImage default -->
                      </div>
                      <div class="card-body margin-b">
                        <div class="justify-content">
                          <div class="display row" style="height: 40px">
                            <!-- <div class="inner-box col-md-8"> -->
                            <div class="image-wrapper webUrl margin-b" style="
                                position: relative;
                                bottom: 160px;
                                left: 24px;
                              ">
                              <!-- <img
                                class="profile"
                                style="
                                  border-radius: 50%;
                                  height: 150px;
                                  width: 150px;
                                  object-fit: fill;
                                "
                                [src]="renderImage(merchantDetail?.photo)"
                                alt=""
                              /> -->
                              <img class="profile" [src]="merchantDetail?.photo | merchantProfilePhoto" style="
                                  border-radius: 50%;
                                  height: 200px;
                                  width: 200px;
                                  object-fit: fill;
                                " alt="Profile Photo" (error)="onImgError($event, 'assets/default-user.jpg')" />
                            </div>


                            <!-- </div> -->

                            <div class="col-md-7" style="
                                margin: auto;
                                position: relative;
                                bottom: 70px;
                                left: 70px;
                              ">
                              <div class="margin-l-l mDetail" style="display: flex;
                              flex-direction: column;
                              justify-content: center;
                              align-items: center;">
                                <button *ngIf="activeTab == 'merchant' && loading" class="anchor"
                                  routerLink="/update-profile" [routerLinkActive]="'activeFeature'">
                                  Update Profile
                                </button>
                                <span class="cursor row">
                                  Followers:
                                  {{ merchantDetail?.followersCount }}
                                </span>
                                <span class="cursor row">Visitors:
                                  {{ merchantDetail?.visitorsCount }}</span>
                              </div>
                            </div>
                          </div>

                          <!-- <div>
                            <div class="display">
                              <div class="cursor">
                                <a
                                  href="http://partner.audiolasitava.lv/publisherDetail"
                                  target="_blank"
                                  >{{ merchantDetail?.website }}</a
                                > -->
                          <!-- <a
                                  href="{{ merchantDetail?.website }}"
                                  target="_blank"
                                >
                                  <img
                                    src="assets/social.png"
                                    style="height: 40px"
                                /></a>
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                      <div class="card-body mTop150">
                        <div class="border-b margin-b">
                          <div class="margin-l border-b">
                            <p class="margin-b title-font" style="font-size: 22px">
                              <span>
                                <img src="assets/faithcross.png" style="height: 22px" />
                              </span>
                              {{ merchantDetail?.name }}
                            </p>
                            <span *ngIf="merchantDetail?.badgeCaption" [ngClass]="merchantDetail?.badge">

                              <!-- Church Connected -->
                              <div *ngIf="merchantDetail?.isChurchMemberOwned" class="badge-wrapper">
                                <img src="assets/ChurchConnected.png" alt="Church Connected Badge"
                                  class="profile-badge-icon" />
                              </div>

                              <!-- Community Trusted -->
                              <div *ngIf="merchantDetail?.isCommunityRecommended" class="badge-wrapper">
                                <img src="assets/CommunityTrusted.png" alt="Community Recommended Badge"
                                  class="profile-badge-icon" />
                              </div>

                              <!-- Founding Partner -->
                              <div *ngIf="merchantDetail?.badgeCaption === 'Founding Partner'" class="badge-wrapper">
                                <img src="assets/FoundingPartner.png" alt="Founding Partner Badge"
                                  class="profile-badge-icon" />
                              </div>
                              <!-- Kingdom Partner -->
                              <div *ngIf="merchantDetail?.badgeCaption === 'Kingdom Partner'" class="badge-wrapper">
                                <img src="assets/KingdomPartner.png" alt="Kingdom Partner Badge"
                                  class="profile-badge-icon" />
                              </div>

                            </span>
                          </div>
                        </div>
                        <div class="border-b margin-b">
                          <div class="margin-l border-b">
                            <i class="margin-b title-font">
                              <!-- <span>
                                <img
                                  src="assets/faithcross.png"
                                  style="height: 22px"
                                />
                              </span> -->
                              {{ merchantDetail?.logLine }}
                            </i>
                          </div>
                        </div>

                        <div class="display border-b margin-b" *ngIf="getValidation(merchantDetail?.shortBio)">
                          <div class="margin-l w-100">
                            <p class="title decrip" style="text-transform: capitalize">
                              {{ merchantDetail?.shortBio }}
                            </p>
                          </div>
                        </div>
                        <div class="border-b margin-b" *ngIf="getValidation(merchantDetail?.customCategory)">
                          <label class="font-weight-bold">Business Category: </label>
                          <h6 class="card-title font-weight" style="text-align: justify">
                            {{
                            merchantDetail.customCategory.length != 0
                            ? merchantDetail.customCategory[0]?.title
                            : "--"
                            }}
                          </h6>
                          <p class="margin-b">
                            {{
                            merchantDetail?.customCategory.length != 0
                            ? merchantDetail?.customCategory[1]?.description
                            : "--"
                            }}
                          </p>
                        </div>
                        <div class="display border-b margin-b" *ngIf="getValidation(merchantDetail?.name)">
                          <span class="ml-2">
                            <img src="assets/org.png" style="height: 20px" />
                          </span>
                          <div class="margin-l border-b">
                            <p class="margin-b">
                              {{ businessType }}
                            </p>
                          </div>
                        </div>

                        <div class="display border-b margin-b" *ngIf="getValidation(merchantDetail?.name)">
                          <div class="margin-l border-b">

                            <span style="font-weight: 600">
                              Values / Statement of Faith:
                            </span>
                            <p>{{ merchantDetail?.menu }}</p>

                            <p class="margin-b">
                              <span style="font-weight: 600">
                                Faith:
                              </span> {{ merchantDetail?.faith?.name }}
                              {{
                              merchantDetail?.subFaith?.name
                              ? "/ " + merchantDetail?.subFaith?.name
                              : ""
                              }}
                              {{
                              merchantDetail?.subFaith2?.name
                              ? "/ " + merchantDetail?.subFaith2?.name
                              : ""
                              }}
                            </p>
                            <div class="affliated" style="display: flex">
                              <span>
                                <img src="assets/christian-academy.png" style="height: 20px" />
                              </span>
                              <div class="margin-l">
                                <p class="margin-b title-font">
                                  {{ merchantDetail?.affliatedBy?.name }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- <div
                          class="display border-b margin-b"
                          *ngIf="
                            getValidation(merchantDetail?.affliatedBy?.name)
                          "
                        >
                          <div>
                            <img
                              src="assets/christian-academy.png"
                              style="height: 20px"
                            />
                          </div>
                          <div class="margin-l">
                            <p class="margin-b title-font">
                              {{ merchantDetail?.affliatedBy?.name }}
                            </p>
                          </div>
                        </div> -->

                        <div class="border-b margin-b d-flex justify-content-between"
                          *ngIf="getValidation(merchantDetail?.shortBio)">
                          <h5 class="card-title font-weight">Business Info</h5>
                          <!-- <div class="custom-control custom-switch">
                            <span style="margin-right: 45px">{{
                              !isHideAddress
                                ? "Hide Contact Name"
                                : "Display Contact Name"
                            }}</span>
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              [(ngModel)]="isHideAddress"
                              (change)="hideAddress($event)"
                              [checked]="isHideAddress"
                              id="customSwitch1"
                            />
                            <label
                              class="custom-control-label"
                              for="customSwitch1"
                            ></label>
                          </div> -->
                        </div>
                        <div class="border-b margin-b">
                          <div class="display">
                            <div>
                              <img src="assets/location.png" style="height: 30px" />
                            </div>
                            <div class="margin-l-l">
                              <a class="cursor" href="https://www.google.com/maps/search/?api=1&query={{
                                  merchantDetail?.address?.streetAddress
                                }}" target="_blank">
                                <p class="address-text" *ngIf="merchantDetail?.showStreetAddress; else fullAddress">
                                  {{ merchantDetail?.address?.city }},
                                  {{ merchantDetail?.address?.state }},
                                  {{ merchantDetail?.address?.postalCode }}
                                </p>
                                <ng-template #fullAddress>
                                  <p class="address-text">
                                    {{ merchantDetail?.address?.streetAddress }},
                                    {{ merchantDetail?.address?.city }},
                                    {{ merchantDetail?.address?.state }},
                                    {{ merchantDetail?.address?.postalCode }}
                                  </p>
                                </ng-template>
                              </a>
                            </div>
                          </div>

                          <div class="display" *ngFor="
                              let props of merchantDetail?.alternateAddress;
                              let i = index
                            ">
                            <div>
                              <img src="assets/location.png" style="height: 30px" />
                            </div>
                            <div class="margin-l-l">
                              <a class="cursor" href="https://www.google.com/maps/search/?api=1&query={{
                                  props.streetAddress
                                }}" target="_blank">
                                <p class="address-text">
                                  {{ props.streetAddress }}
                                </p>
                              </a>
                            </div>
                          </div>

                          <div class="display" *ngIf="getValidation(merchantDetail?.contactNo)">
                            <div>
                              <img src="assets/christian-academy.png" style="height: 20px" />
                            </div>
                            <div class="margin-l-l">
                              <p class="margin-b address-text">
                                Main:{{ merchantDetail?.contactNo }}
                              </p>
                            </div>
                          </div>
                          <div class="display" *ngIf="
                              getValidation(merchantDetail?.AlternateContactNO)
                            ">
                            <div>
                              <img src="assets/christian-academy.png" style="height: 20px" />
                            </div>
                            <div class="margin-l-l">
                              <p class="address-text">
                                Alternate:{{
                                merchantDetail?.AlternateContactNO
                                }}
                              </p>
                            </div>
                          </div>

                          <div class="margin-b display" *ngIf="
                              getValidation(merchantDetail?.HotLinkContactNo)
                            ">
                            <div>
                              <img src="assets/christian-academy.png" style="height: 20px" />
                            </div>
                            <div class="margin-l-l">
                              <p class="margin-b address-text">
                                Direct:{{
                                merchantDetail?.HotLinkContactNo
                                ? merchantDetail?.HotLinkContactNo
                                : "--"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="margin-b display" *ngIf="getValidation(merchantDetail?.email)">
                            <div>
                              <img src="assets/email.png" style="height: 30px" />
                            </div>
                            <div class="margin-l-l">
                              <p class="margin-b address-text">
                                {{ merchantDetail?.email }}
                              </p>
                            </div>
                          </div>

                          <div class="margin-b display" *ngIf="
                              getValidation(merchantDetail?.userName) &&
                              !merchantDetail?.isBusinessContactNameVisible
                            ">
                            <div>
                              <img src="assets/user.png" style="height: 30px" />
                            </div>
                            <div class="margin-l-l">
                              <p class="margin-b address-text">
                                {{ merchantDetail?.userName | titlecase }}
                              </p>
                            </div>
                          </div>

                          <div class="margin-b display" *ngIf="getValidation(merchantDetail?.website)">
                            <div>
                              <img src="assets/web.png" style="height: 30px" />
                            </div>
                            <div class="margin-l-l">
                              <a class="cursor" [href]="merchantDetail?.website" target="_blank">
                                <p class="margin-b address-text">
                                  {{ merchantDetail?.website }}
                                </p>
                              </a>
                            </div>
                          </div>

                          <div class="mb-3 public_url" *ngIf="merchantDetail?.businessUserName != null">
                            <h6>Your Public Url:</h6>
                            <a (click)="goToUrl()">{{ profileUrl }}</a>
                          </div>

                          <div class="bussiness-hours">
                            <h2>Business Hours</h2>
                            <p class="p-class">
                              <img class="col-md-2" src="assets/clock.png" />
                              {{ weeklyTime[0]?.name }},
                              {{ weeklyTime[0]?.start | date : "h:mm a " }} -
                              {{ weeklyTime[0]?.finish | date : "h:mm a" }}
                              <img (click)="daysToggle()" class="col-md-2" src="assets/dropDown.png" style="
                                  height: auto !important;
                                  transform: rotate(90deg);
                                " />
                            </p>

                            <div style="margin-left: 77px" *ngIf="show">
                              <div class="row" *ngFor="let sun of weeklyTime">
                                <span *ngIf="sun.start">
                                  {{ sun.name }},
                                  {{ sun.start | date : "h:mm a " }} -
                                  {{ sun.finish | date : "h:mm a" }}</span>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="imageObject.length > 0">
                            <ng-image-slider [images]="imageObject" #nav></ng-image-slider>
                          </div>

                          <!-- <div class="main-box margin-b ">
                            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                              <div ngxSlickItem *ngFor="let props of  photoGallery; let i = index;" class="slide">
                                <div class="main-wrapper">

                                  <div class="cursor">
                                    <div class="inner-warpper">
                                      <div class="margin-b">
                                        <img [src]="renderImage(props)" class="image-style" alt="">
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ngx-slick-carousel>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="activeTab == 'visitors'">
            <div *ngFor="let community of visitors">
              <div class="row">
                <div class="col-md-1">
                  <div class="community-image">
                    <img class="community" [src]="
                        checkImage(community.by.photo)
                          ? checkImage(community.by.photo)
                          : 'assets/default-user.jpg'
                      " />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="community-name">
                    {{ community.by.name }}
                  </div>
                </div>

                <div class="col-md-5">
                  <div class="community-email">
                    {{ community.email }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="activeTab == 'fellowships'">
            <div *ngFor="let follower of followers" class="row">
              <div class="col-md-1" *ngIf="follower?.name">
                <div class="community-image">
                  <img class="community" [src]="
                      checkImage(follower.photo)
                        ? checkImage(follower.photo)
                        : 'assets/default-user.jpg'
                    " />
                </div>
              </div>

              <div class="col-md-11">
                <div class="community-name">
                  {{ follower.name }}
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="activeTab == 'inquiries'">
            <div *ngIf="inquiries?.length; else noInquiries">
              <div *ngFor="let inquiry of inquiries; let i = index" class="row" (click)="markInquirySeen(inquiry)"
                style="border-bottom: 1px solid #eee; padding: 12px 0; align-items: center; cursor: pointer;"
                [style.background]="inquiry.status === 'new' ? '#fff8e1' : 'transparent'">
                <div class="col-md-1" style="position: relative;">
                  <span *ngIf="inquiry.status === 'new'" style="
          position: absolute;
          top: -4px;
          left: 4px;
          background: #f59e0b;
          color: #fff;
          border-radius: 10px;
          padding: 1px 6px;
          font-size: 10px;
          font-weight: 700;
        ">{{ i + 1 }}</span>
                  <div class="community-image">
                    <img class="community" [src]="
    checkImage(inquiry.user?.photo)
      ? checkImage(inquiry.user?.photo)
      : 'assets/default-user.jpg'
  " />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="community-name">
                    {{ inquiry.user?.name || inquiry.user?.userName || 'User' }}
                  </div>
                  <small [ngStyle]="{
          color: inquiry.status === 'new' ? '#f59e0b' : (inquiry.status === 'resolved' ? '#16a34a' : '#6b7280'),
          fontWeight: 700,
          textTransform: 'capitalize'
        }">{{ inquiry.status }}</small>
                </div>
                <div class="col-md-5">
                  <div class="community-email">{{ inquiry.message }}</div>
                </div>
                <div class="col-md-2">
                  <small>{{ inquiry.createdAt | date : 'MMM d, y, h:mm a' }}</small>
                </div>
              </div>
            </div>
            <ng-template #noInquiries>
              <p style="text-align: center; padding: 20px; color: #888;">
                No inquiries received yet.
              </p>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 col-lg-3 col-xs-3 col-sm-12"
        *ngIf="perpetualAdd?.description && perpetualAdd?.imagePath">
        <nav class="col-md-12 col-lg-12">
          <div id="fixed-sidebar">
            <div class="card">
              <article class="card-group-item">
                <header class="card-header profile-discount">
                  <h5>Member Discount</h5>
                </header>
                <div class="perpetual">
                  <div class="card-body perpetual-ad-body">
                    <label class="form-check">
                      <p class="shadow bg-white rounded perpetual-image">
                        {{ perpetualAdd?.description }}
                      </p>
                      <span class="form-check-label perpetual-image-bottom">
                        <img class="responsive-image" [src]="checkImage(perpetualAdd?.imagePath)" />
                      </span>
                    </label>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>

<div id="myModal" class="modal" [ngClass]="{ show: isModalVisible }" (click)="onBackdropClick($event)">
  <div class="modal-content">
    <div class="cross" style="height: 12px">
      <p class="close" (click)="closeModal()">X</p>
    </div>
    <div class="modal-body">
      <div class="modal-left">
        <div class="para">
          <p style="font-size: 26px; color: #d0550e; text-align: center">
            Limited Lifetime Offer
          </p>
          <p style="font-size: 22px; color: blue; text-align: center">
            Go Global and Save $500
          </p>
          <p style="font-size: 20px; color: #000; text-align: center">
            As we prepare to launch, upgrade <br />
            your free Congregational profile to <br />
            our Founder plan and we'llgive you:
          </p>
          <p style="font-size: 26px; color: #d0550e; text-align: center">
            Global, lifetime access for just $495
          </p>
          <p style="font-size: 20px; color: #000; text-align: center">
            This exclusive offer won't last long.<br />
            After we launch, the price will return to $995.
          </p>
          <p style="
              font-size: 19px;
              color: blue;
              text-align: center;
              cursor: pointer;
              text-decoration: underline;
            " (click)="openSubscription()">
            Click to SUBSCRIBE
          </p>
          <label *ngIf="isUserLoggedIn" id="doNotShowContainer"
            style="font-size: 20px; position: absolute; top: 90%; left: 30px;">
            <input type="checkbox" id="doNotShowAgain" (change)="handleDoNotShow($event)" [checked]="doNotShowAgain">
            Do not show for 1 month
          </label>
        </div>
      </div>
      <div class="modal-right">
        <span style="font-size: 28px;
        font-weight: 500;
        color: blue;
        margin-bottom: 12px;
    ">Drive More Traffic!</span>
        <iframe id="videoFrame" title="vimeo-player" src="https://player.vimeo.com/video/1015943861?h=27a680bc09"
          width="450" height="300" frameborder="0" allowfullscreen style="margin-left: 46px;"></iframe>
        <p style="    font-size: 20px;
        width: 110px;
        position: relative;
        left: 200px;">Click to play</p>
      </div>
    </div>
  </div>
</div>

<!-- #d0550e -->